<template>
  <b-card no-body class="mt-3 mb-3">

    <b-card-header align="left">
      <h1 v-if="isLoggedIn">Account Details</h1>
      <h1 v-if="!isLoggedIn">Enter New Account Information</h1>
    </b-card-header>
    <b-card-body>

      <b-form>

        <rx-text-entry-box
            v-model="first_name"
            id="firstNameInput"
            title-text="First Name"
            placeholder="Enter Your First Name"
            :validation="$v.first_name"
        ></rx-text-entry-box>

        <rx-text-entry-box
            v-model="last_name"
            id="lastNameInput"
            title-text="Last Name"
            placeholder="Enter Your Last Name"
            :validation="$v.last_name"
        ></rx-text-entry-box>


        <rx-text-entry-box
            v-model="title"
            id="titleInput"
            title-text="Your Title"
            placeholder="Enter your title"
            :validation="$v.title"
        ></rx-text-entry-box>

        <rx-text-entry-box
            v-model="organizationName"
            id="organizationNameInput"
            title-text="Organization Name"
            placeholder="Enter Your Organization's Name"
            :validation="$v.organizationName"
        ></rx-text-entry-box>

         <rx-text-entry-box
            v-model="email"
            id="emailInput"
            title-text="Email"
            input-type="email"
            placeholder="Enter Your Email"
            :is-disabled="isLoggedIn"
            description=""
            :validation="$v.email"
        ></rx-text-entry-box>

        <rx-dropdown
            v-model="state"
            id="stateInput"
            :options="stateOptions"
            description="Enter the name of the state in which you work"
            title-text="State"
            v-bind:dropdown-col-size="4"
            :validation="$v.state"
        ></rx-dropdown>

        <rx-text-entry-box
            v-model="country"
            id="countryInput"
            description="Enter the name of the country in which you work"
            title-text="Country"
            :validation="$v.country"
        ></rx-text-entry-box>
        <b-button block
                  :disabled="!$v.$anyDirty"
                  :variant="$v.$anyDirty ? 'success' : 'light'"
                  @click="saveUserChanges"
        >Save Changes</b-button>

      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
  import store from './../../store/store.js'
  import { mapGetters } from 'vuex';
  import { mapFields } from 'vuex-map-fields';
  import { validationMixin } from 'vuelidate';
  import { helpers, maxLength } from 'vuelidate/lib/validators';
  import { required, sameAs, between, minLength} from 'vuelidate/lib/validators'

  import RxTextEntryBox from './project/inputComponents/RxTextEntryBox'
  import RxDropdown from './project/inputComponents/RxDropdown'
  import {states} from "../../js/stateAbbreviations";

  const stateValidator = helpers.withParams(
    {type: 'required'},
    (state) => state.value !== null
  );

  export default {
		name: "AccountPage",
    components: {
		  RxTextEntryBox,
      RxDropdown
    },
    mixins:[
      validationMixin
    ],
    data: function(){
		  return {
		    stateOptions: states,
      }
    },
    computed: {
		  ...mapFields('account',[
		    "user",
		    "user.first_name",
        "user.last_name",
        "user.email",
        "user.country",
        "user.state",
        "user.title",
        "user.organizationName",
      ]),
      ...mapGetters('account',['isLoggedIn'])
    },
    methods: {
		  saveUserChanges(){
		    this.$v.$touch();
		    // const result = store.dispatch('account/updateUser');
        // console.log('Update user result:', result);
      },
      setPasswordValidationState(){
		    if (this.password1 == this.password2){
		      return true
        } else {
		      return false
        }
      }
    },
    validations: {
		  first_name: {
		    required,
        maxLength: maxLength(100)
      },
      last_name: {
		    required,
        maxLength: maxLength(100)
      },
      email: {
		    required,
        maxLength: maxLength(200)
      },
      state: {
        required: stateValidator
      },
      country:{
		    required,
        maxLength: maxLength(100)
		  },
    },
    mounted(){
		  this.$v.$reset();
    }
	}
</script>

<style scoped>

</style>